module.exports = "/images/id-step4ja.png?45a312f3e365c79b1dc47f664e2a1b45";